import { AmplitudeInteractionChannel } from 'Src/models/Amplitude/InteractionChannels';
import { useMedia } from 'Utils/mediaQuery';

export default function useInteractionChannel() {
  const isLg = useMedia('lg');

  return isLg
    ? AmplitudeInteractionChannel.WEB_DESKTOP
    : AmplitudeInteractionChannel.WEB_MOBILE;
}
